import { Location } from "@gatsbyjs/reach-router"
import * as React from "react"
import { Visible } from "react-grid-system"
import styled from "styled-components"
import { ButtonLink } from "styleguide/components/Button"
import { fontFamily } from "styleguide/styles/fonts"
import Dropdown from "./Dropdown"
import MenuLink from "./MenuLink"

const StyledButton = styled(ButtonLink)`
  font-size: 16px;
  font-family: ${fontFamily("base")};
  font-weight: 600;
  padding-top: 12px;
  padding-bottom: 12px;
`

const MenuWrapper = styled.div`
  display: flex;
  width: 100%;
`

const isCurrent = (pathname, url) => {
  if (pathname === null) {
    return false
  }
  const path = pathname.slice(1).split("/")[0]
  return url.indexOf(path) !== -1
}

const Menu = () => (
  <Location>
    {({ location }) => {
      const { pathname } = location

      return (
        <MenuWrapper>
          <MenuLink
            isCurrent={isCurrent(pathname, [
              "About us",
              "Client engagement model",
              "We're hiring",
            ])}
            title="About"
            content={
              <Dropdown>
                <MenuLink title="About us" url="/about/" />
                <MenuLink
                  title="Client engagement model"
                  url="/blog/client-engagement-model/"
                />
                <MenuLink title="We're hiring" url="/career/" />
              </Dropdown>
            }
          />
          <MenuLink
            title="Services"
            isCurrent={isCurrent(pathname, [
              "services",
              "design",
              "react-on-rails-pro",
            ])}
            content={
              <Dropdown>
                <MenuLink title="What we do" url="/services/" />
                <MenuLink title="Design" url="/design" />
                <MenuLink
                  title="React on Rails Pro"
                  url="/react-on-rails-pro/"
                />
                <MenuLink
                  title="Web Scraping & Data Analysis"
                  url="/services/web-scraping-and-data-analysis"
                />
                <MenuLink title="AI Consulting" url="/services/ai-consulting" />
                <MenuLink
                  title="IT Infrastructure Optimization"
                  url="/services/it-infrastructure-optimization"
                />
              </Dropdown>
            }
          />
          <MenuLink
            title="Portfolio"
            isCurrent={isCurrent(pathname, ["recent-work", "hichee", "open-source-projects"])}
            content={
              <Dropdown>
                <MenuLink title="Recent work" url="/recent-work/" />
                <MenuLink title="HiChee.com" url="/hichee/" />
                <MenuLink
                  title="Open Source Projects"
                  url="/open-source-projects/"
                />
              </Dropdown>
            }
          />
          <MenuLink
            title="Insights"
            content={
              <Dropdown>
                <MenuLink title="Blog" url="/blog/" />
                <MenuLink
                  title="Forum"
                  externalLink
                  url="https://forum.shakacode.com"
                />
                <MenuLink title="Talks" url="/talks/" />
              </Dropdown>
            }
          />
          <MenuLink
            title="Docs"
            content={
              <Dropdown>
                <MenuLink
                  title="React on Rails"
                  url="/react-on-rails/docs/"
                />
                <MenuLink
                  title="React on Rails Pro"
                  url="/react-on-rails-pro/docs/"
                />
                <MenuLink
                  title="Control Plane flow"
                  url="/control-plane-flow/docs/"
                />
              </Dropdown>
            }
          />

          <Visible lg xl>
            <StyledButton
              href="https://meetings.hubspot.com/justingordon/30-minute-consultation"
              target="_blank"
            >
              Book a free call
            </StyledButton>
          </Visible>
        </MenuWrapper>
      )
    }}
  </Location>
)

export default Menu
